import { InscriptionsSummaryByBP } from '../BudgetManagement/InitInscriptions/type';

export enum InitialisationStatus {
    IN_PROGRESS = 'in_progress',
    SUCCESS = 'success',
    FAILED = 'failed',
}

export type InitialisationT = {
    executionSummary: InscriptionsSummaryByBP[];
    status: InitialisationStatus;
    updatedAt: string;
    deleted: boolean;
    hasInscriptionLinked: boolean;
};

export type InitialisationAvailableT = {
    available: boolean;
};
